
(function(){
  var root=document.querySelector('.hs'); if(!root) return;
  var imgs=root.querySelectorAll('.hero-bg img'), slides=root.querySelectorAll('.hs-slide'), dots=root.querySelectorAll('.hs-dot'), pause=root.querySelector('.hs-pause');
  var DUR=7000, i=0, t=null, paused=false, reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.style.setProperty('--hs-dur',DUR+'ms');
  function go(n){
    i=(n+slides.length)%slides.length;
    slides.forEach(function(s,k){var on=k===i; s.classList.toggle('is-on',on); s.setAttribute('aria-hidden',on?'false':'true'); s.querySelectorAll('a').forEach(function(a){on?a.removeAttribute('tabindex'):a.setAttribute('tabindex','-1')});});
    imgs.forEach(function(m,k){m.classList.toggle('is-on',k===i); if(k===i) m.loading='eager';});
    dots.forEach(function(d,k){d.setAttribute('aria-current',k===i?'true':'false'); var sp=d.firstElementChild; sp.style.animation='none'; sp.offsetWidth; sp.style.animation='';});
    schedule();
  }
  function schedule(){clearTimeout(t); if(!paused&&!reduce) t=setTimeout(function(){go(i+1)},DUR);}
  dots.forEach(function(d,k){d.addEventListener('click',function(){go(k)})});
  pause.addEventListener('click',function(){paused=!paused; root.classList.toggle('is-paused',paused); pause.textContent=paused?'▶':'❚❚'; pause.setAttribute('aria-label',paused?'Play slideshow':'Pause slideshow'); schedule();});
  if(reduce){paused=true; root.classList.add('is-paused'); pause.textContent='▶'; pause.setAttribute('aria-label','Play slideshow');}
  // swipe
  var x0=null,y0=null;
  root.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;y0=e.touches[0].clientY},{passive:true});
  root.addEventListener('touchend',function(e){if(x0===null)return; var dx=e.changedTouches[0].clientX-x0, dy=e.changedTouches[0].clientY-y0; if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)) go(i+(dx<0?1:-1)); x0=null;},{passive:true});
  // pause while off-screen or tab hidden
  document.addEventListener('visibilitychange',function(){document.hidden?clearTimeout(t):schedule()});
  if('IntersectionObserver' in window) new IntersectionObserver(function(es){es[0].isIntersecting?schedule():clearTimeout(t)}).observe(root);
  schedule();
})();


(function(){
  var grid=document.getElementById('gal-grid'), btn=document.getElementById('gal-more'), count=document.getElementById('gal-count');
  if(!grid) return;
  if(btn) btn.addEventListener('click',function(){
    var open=grid.classList.toggle('is-open');
    btn.setAttribute('aria-expanded',String(open));
    btn.textContent=open?'Show less':'See more of the work';
    if(!open) grid.scrollIntoView({behavior:'smooth',block:'start'});
  });
  if(count){
    var items=grid.querySelectorAll('.gal-item'), t;
    grid.addEventListener('scroll',function(){
      clearTimeout(t); t=setTimeout(function(){
        var w=items[0].getBoundingClientRect().width+14, i=Math.round(grid.scrollLeft/w);
        count.textContent=Math.min(i+1,items.length)+' / '+items.length;
      },60);
    },{passive:true});
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  // Chooser tabs (WAI-ARIA tabs pattern)
  var tabs = [].slice.call(document.querySelectorAll('.wc-tab'));
  function select(t, focus) {
    tabs.forEach(function (x) {
      var on = x === t;
      x.setAttribute('aria-selected', on ? 'true' : 'false');
      x.tabIndex = on ? 0 : -1;
      document.getElementById(x.getAttribute('aria-controls')).hidden = !on;
    });
    if (focus) t.focus();
    t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { select(t); });
    t.addEventListener('keydown', function (e) {
      var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
      if (n === null) return;
      e.preventDefault(); select(tabs[(n + tabs.length) % tabs.length], true);
    });
  });

  // Sticky mobile bar: show after the hero, hide over the closing CTA and footer
  var sb = document.getElementById('sb'), hero = document.querySelector('.hero');
  if (!sb || !hero || !('IntersectionObserver' in window)) return;
  document.body.classList.add('has-sb');
  var link = sb.querySelector('a'), pastHero = false, nearEnd = false;
  function upd() {
    var on = pastHero && !nearEnd;
    sb.classList.toggle('is-on', on);
    sb.setAttribute('aria-hidden', on ? 'false' : 'true');
    link.tabIndex = on ? 0 : -1;
  }
  new IntersectionObserver(function (es) { pastHero = !es[0].isIntersecting; upd(); }, { threshold: 0 }).observe(hero);
  var end = document.querySelectorAll('.featured-listing, .cta-band, .site-footer');
  var vis = new Set();
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.isIntersecting ? vis.add(e.target) : vis.delete(e.target); });
    nearEnd = vis.size > 0; upd();
  });
  end.forEach(function (el) { io.observe(el); });
});
